import { GroupDiningSearchResult } from '../GroupDiningComponent.types';

export const groupDiningMock: { data: { searchRestaurantsByGeolocation: GroupDiningSearchResult } } = {
  data: {
    searchRestaurantsByGeolocation: {
      edges: [
        {
          node: {
            basicInformation: {
              reservationUrl: 'http://www.opentable.com/restaurant/profile/1017811/reserve?restref=1017811',
            },
            contactInformation: {
              address: {
                city: 'New York',
                country: {
                  description: 'USA',
                },
                stateProvince: 'New York',
              },
            },
            cuisine: 'American',
            contactNumbers: [
              {
                phoneNumber: {
                  countryCode: '31',
                  original: null,
                  international: null,
                  national: null,
                  display: '+31 20 2415002',
                  areaCityCode: '20',
                  extension: null,
                  number: '2415002',
                },
              },
            ],
            description:
              "Unwind with a classic cocktail at our hotel bar in Midtown. Located near Bryant Park, it's one of NYC's most historic destinations. Our hotel bar and lounge in New York City is the perfect place to enjoy dinner and a cocktail at the end of your day.",
            diningExperience: {
              affordabilityPriceIndicator: null,
              capacity: 40,
              cuisines: ['French'],
              experiences: ['Private Functions'],
              hasPrivateDiningRoom: true,
              privateDiningRoomCapacity: 8,
              seatings: ['Private Dining Room'],
            },
            contactInfo: {
              contactNumbers: [
                {
                  phoneNumber: {
                    display: '+1 808 729-9729',
                  },
                },
              ],
            },
            id: 'NYCAK.5178523',
            media: {
              imageConnection: null,
            },
            name: 'Blue Bar Restaurant and Lounge',
            operationalDetails: {
              restaurantSoftware: null,
              restaurantSoftwareId: null,
            },
            primaryType: 'Restaurant',
            productId: '5178523',
            property: {
              basicInformation: {
                latitude: 40.755589,
                longitude: -73.981863,
                name: 'The Algonquin Hotel Times Square, Autograph Collection',
              },
            },
            secondaryType: 'Bar',
            seoUrl:
              'restaurant-bar/nycak-the-algonquin-hotel-times-square-autograph-collection/5178523-blue-bar-restaurant-and-lounge',
          },
        },
        {
          node: {
            basicInformation: {
              reservationUrl: null,
            },
            contactInformation: {
              address: {
                city: 'New York',
                country: {
                  description: 'USA',
                },
                stateProvince: 'New York',
              },
            },
            cuisine: 'American',
            contactNumbers: null,
            description:
              'Midtown Manhattan hotel with free breakfast in New York available for Registered Hotel Guests - this hotel in NYC with a free breakfast buffet offers a daily selection of hot and cold items, eggs, fruit, fresh bread, coffee, and juices.',
            diningExperience: {
              affordabilityPriceIndicator: null,
              capacity: 50,
              cuisines: ['Multiple cuisines'],
              experiences: ['Private Functions'],
              hasPrivateDiningRoom: true,
              privateDiningRoomCapacity: 20,
              seatings: ['Private Dining Room'],
            },
            contactInfo: {
              contactNumbers: [
                {
                  phoneNumber: {
                    display: '+1 808 9318638',
                  },
                },
              ],
            },
            id: 'NYCSM.6866241',
            media: {
              imageConnection: {
                edges: [
                  {
                    node: {
                      alternateDescription: 'New York Hotel in Midtown Manhattan',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCSM/nycsm-dining-0010-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCSM/nycsm-dining-0010-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCSM/nycsm-dining-0010-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCSM/nycsm-dining-0010-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCSM/nycsm-dining-0010-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: true,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycsm-dining-0010',
                    },
                  },
                ],
                total: 1,
              },
            },
            name: 'Lobby Breakfast Buffet',
            operationalDetails: {
              restaurantSoftware: null,
              restaurantSoftwareId: null,
            },
            primaryType: 'Restaurant',
            productId: '6866241',
            property: {
              basicInformation: {
                latitude: 40.751190185546875,
                longitude: -73.9845962524414,
                name: 'SpringHill Suites by Marriott New York Midtown Manhattan/Fifth Avenue',
              },
            },
            secondaryType: null,
            seoUrl:
              'restaurant-bar/nycsm-springhill-suites-new-york-midtown-manhattan-fifth-avenue/6866241-lobby-breakfast-buffet',
          },
        },
        {
          node: {
            basicInformation: {
              reservationUrl: null,
            },
            contactInformation: {
              address: {
                city: 'New York',
                country: {
                  description: 'USA',
                },
                stateProvince: 'New York',
              },
            },
            cuisine: 'American',
            contactNumbers: [
              {
                phoneNumber: {
                  countryCode: '31',
                  original: null,
                  international: null,
                  national: null,
                  display: '+31 20 2415002',
                  areaCityCode: '20',
                  extension: null,
                  number: '2415002',
                },
              },
            ],
            description:
              'Treat your guests to an entree or a beverage at our on-site restaurant & bar, Bryant Park Lounge, serving classic favorites.',
            diningExperience: {
              affordabilityPriceIndicator: null,
              capacity: 50,
              cuisines: ['Multiple cuisines'],
              experiences: ['Private Functions'],
              hasPrivateDiningRoom: true,
              privateDiningRoomCapacity: 10,
              seatings: ['Private Dining Room'],
            },
            contactInfo: {
              contactNumbers: [
                {
                  phoneNumber: {
                    display: '+1 808 9318637',
                  },
                },
              ],
            },
            id: 'NYCRI.5719401',
            media: {
              imageConnection: {
                edges: [
                  {
                    node: {
                      alternateDescription: 'Unwind at lobby lounge near Rockefeller Center',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCRI/nycri-lounge-0057-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCRI/nycri-lounge-0057-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCRI/nycri-lounge-0057-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCRI/nycri-lounge-0057-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCRI/nycri-lounge-0057-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycri-lounge-0057',
                    },
                  },
                ],
                total: 1,
              },
            },
            name: 'Bryant Park Lounge',
            operationalDetails: {
              restaurantSoftware: null,
              restaurantSoftwareId: null,
            },
            primaryType: 'Restaurant',
            productId: '5719401',
            property: {
              basicInformation: {
                latitude: 40.752689,
                longitude: -73.985654,
                name: 'Residence Inn by Marriott New York Manhattan/Times Square',
              },
            },
            secondaryType: null,
            seoUrl: 'restaurant-bar/nycri-residence-inn-new-york-manhattan-times-square/5719401-bryant-park-lounge',
          },
        },
        {
          node: {
            basicInformation: {
              reservationUrl: null,
            },
            contactInformation: {
              address: {
                city: 'New York',
                country: {
                  description: 'USA',
                },
                stateProvince: 'New York',
              },
            },
            cuisine: 'American',
            contactNumbers: null,
            description:
              'Enjoy casual, healthy dining at our bistro, nosh!. Start your day in New York City with balanced entrees and Starbucks coffee. Our Times Square restaurant keeps you refreshed during travel.',
            diningExperience: {
              affordabilityPriceIndicator: null,
              capacity: 60,
              cuisines: ['Multiple cuisines'],
              experiences: ['Large Parties (>10)', 'Private Functions'],
              hasPrivateDiningRoom: true,
              privateDiningRoomCapacity: 15,
              seatings: ['Private Dining Room'],
            },
            contactInfo: {
              contactNumbers: null,
            },
            id: 'NYCMD.75547',
            media: {
              imageConnection: {
                edges: [
                  {
                    node: {
                      alternateDescription: 'Cafe with food and beverages',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Pano-Ver',
                        square: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Square',
                        wideHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbreakfast-1-40304:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'NYCMD-Noshbreakfast-1',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Bar with stools ',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Pano-Ver',
                        square: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Square',
                        wideHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-noshbar-1-30676:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'NYCMD-NOSHBAR-1',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Large table with chairs',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Pano-Ver',
                        square: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Square',
                        wideHorizontal: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/cy-nycmd-nycmd-communaltable-1-17021:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'NYCMD-CommunalTable-1',
                    },
                  },
                ],
                total: 3,
              },
            },
            name: 'nosh!',
            operationalDetails: {
              restaurantSoftware: null,
              restaurantSoftwareId: null,
            },
            primaryType: 'Restaurant',
            productId: '75547',
            property: {
              basicInformation: {
                latitude: 40.753891,
                longitude: -73.985825,
                name: 'Courtyard by Marriott New York Manhattan/Times Square',
              },
            },
            secondaryType: null,
            seoUrl: 'restaurant-bar/nycmd-courtyard-new-york-manhattan-times-square/75547-nosh',
          },
        },
        {
          node: {
            basicInformation: {
              reservationUrl: 'http://www.opentable.com/restaurant/profile/1198519/reserve?restref=1198519',
            },
            contactInformation: {
              address: {
                city: 'New York',
                country: {
                  description: 'USA',
                },
                stateProvince: 'New York',
              },
            },
            cuisine: 'American',
            contactNumbers: null,
            description:
              'Gather with friends and colleagues at our popular New York City rooftop bar near the Empire State Building and Times Square. Tempting craft cocktails and bar bites partner with stunning views of Midtown under a retractable glass roof above the city.',
            diningExperience: {
              affordabilityPriceIndicator: null,
              capacity: 40,
              cuisines: ['French'],
              experiences: ['Private Functions'],
              hasPrivateDiningRoom: true,
              privateDiningRoomCapacity: 8,
              seatings: ['Private Dining Room'],
            },
            contactInfo: {
              contactNumbers: [
                {
                  phoneNumber: {
                    display: '+1 808 729-9729',
                  },
                },
              ],
            },
            id: 'NYCVC.5808727',
            media: {
              imageConnection: {
                edges: [
                  {
                    node: {
                      alternateDescription: 'Rooftop bar and seating area',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-strand-27342:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Strand 27342',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Rooftop bar and seating area',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-strand-42574-23804:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Strand 42574',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Rooftop bar and seating area',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-strand-37840:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Strand 37840',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Rooftop bar in evening with Empire State building',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-strand-24716:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Strand 24716',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Top of the Strand - Cocktails',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4624-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4624-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4624-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4624-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4624-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycvc-cocktails-4624',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Top of the Strand - Cocktails',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4625-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4625-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4625-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4625-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCVC/nycvc-cocktails-4625-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycvc-cocktails-4625',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Pizza, meats, cheese, and cocktails ',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-strand-39360:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Strand 39360',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Mixed drinks, cocktails ',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-strand-21532:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Strand 21532',
                    },
                  },
                ],
                total: 8,
              },
            },
            name: 'Top of The Strand Rooftop Bar',
            operationalDetails: {
              restaurantSoftware: 'OpenTable',
              restaurantSoftwareId: '1198519',
            },
            primaryType: 'Restaurant',
            productId: '5808727',
            property: {
              basicInformation: {
                latitude: 40.751222,
                longitude: -73.984869,
                name: 'Marriott Vacation Club, New York City',
              },
            },
            secondaryType: null,
            seoUrl: 'restaurant-bar/nycvc-marriott-vacation-club-new-york-city/5808727-top-of-the-strand-rooftop-bar',
          },
        },
        {
          node: {
            basicInformation: {
              reservationUrl: null,
            },
            contactInformation: {
              address: {
                city: 'New York',
                country: {
                  description: 'USA',
                },
                stateProvince: 'New York',
              },
            },
            cuisine: 'American',
            contactNumbers: null,
            description:
              'Get a taste of the historic Garment District of Manhattan. Grab a custom roast coffee, breakfast or fresh pastry before exploring. Unwind with live jazz, and enjoy cocktails, local brewery offerings and savory light bites at our rooftop restaurant in NYC.',
            diningExperience: {
              affordabilityPriceIndicator: null,
              capacity: 40,
              cuisines: ['French'],
              experiences: ['Private Functions'],
              hasPrivateDiningRoom: true,
              privateDiningRoomCapacity: 8,
              seatings: ['Private Dining Room'],
            },
            contactInfo: {
              contactNumbers: [
                {
                  phoneNumber: {
                    display: '+1 808 729-9729',
                  },
                },
              ],
            },
            id: 'NYCVC.6877074',
            media: {
              imageConnection: {
                edges: [
                  {
                    node: {
                      alternateDescription: 'Bar and seating area ',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-40043:Wide-Ver',
                      },
                      isPrimaryArchitectural: true,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Twisted Knot 40043',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Lounge and seating area with fireplace and books',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-21420:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: true,
                      title: 'Twisted Knot 21420',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Lounge, seating area, and outdoor courtyard',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-20594:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Twisted Knot 20594',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Bar and seating area',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-24157:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: true,
                      isSecondaryServices: false,
                      title: 'Twisted Knot 24157',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Musician area with guitar, drums, decorations',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-29724:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Twisted Knot 29724',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Pastries and coffee on deli counter',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Pano-Ver',
                        square: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Square',
                        wideHorizontal: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/mv-nycvc-twisted-knot-28391:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: true,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'Twisted Knot 28391',
                    },
                  },
                ],
                total: 6,
              },
            },
            name: 'Twisted Knot Café and Lounge',
            operationalDetails: {
              restaurantSoftware: null,
              restaurantSoftwareId: null,
            },
            primaryType: 'Restaurant',
            productId: '6877074',
            property: {
              basicInformation: {
                latitude: 40.751222,
                longitude: -73.984869,
                name: 'Marriott Vacation Club, New York City',
              },
            },
            secondaryType: null,
            seoUrl: 'restaurant-bar/nycvc-marriott-vacation-club-new-york-city/6877074-twisted-knot-caf-and-lounge',
          },
        },
        {
          node: {
            basicInformation: {
              reservationUrl: null,
            },
            contactInformation: {
              address: {
                city: 'New York',
                country: {
                  description: 'USA',
                },
                stateProvince: 'New York',
              },
            },
            cuisine: 'Other',
            contactNumbers: null,
            description:
              'Start your day with a continental breakfast in our restaurant, inspired by the Jazz Age history of the hotel. Enjoy a craft cocktail menu that reflects NYC Prohibition-era libations and artisanal bar fare made from locally sourced ingredients.',
            diningExperience: {
              affordabilityPriceIndicator: null,
              capacity: 40,
              cuisines: ['French'],
              experiences: ['Private Functions'],
              hasPrivateDiningRoom: true,
              privateDiningRoomCapacity: 8,
              seatings: ['Private Dining Room'],
            },
            contactInfo: {
              contactNumbers: [
                {
                  phoneNumber: {
                    display: '+1 808 729-9729',
                  },
                },
              ],
            },
            id: 'NYCLX.6595470',
            media: {
              imageConnection: {
                edges: [
                  {
                    node: {
                      alternateDescription: 'Midtown Manhattan Bar- The Stayton Room - Exterior',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCLX/nyclx-exterior-7630-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCLX/nyclx-exterior-7630-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCLX/nyclx-exterior-7630-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCLX/nyclx-exterior-7630-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCLX/nyclx-exterior-7630-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nyclx-exterior-7630',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'Midtown NYC Manhattan Hotel \tUpscale Restaurant',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCLX/nyclx-stayton-7637-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCLX/nyclx-stayton-7637-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCLX/nyclx-stayton-7637-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCLX/nyclx-stayton-7637-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCLX/nyclx-stayton-7637-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nyclx-stayton-7637',
                    },
                  },
                ],
                total: 2,
              },
            },
            name: 'The Stayton Room',
            operationalDetails: {
              restaurantSoftware: null,
              restaurantSoftwareId: null,
            },
            primaryType: 'Restaurant',
            productId: '6595470',
            property: {
              basicInformation: {
                latitude: 40.755013,
                longitude: -73.973252,
                name: 'The Lexington Hotel, Autograph Collection',
              },
            },
            secondaryType: null,
            seoUrl: 'restaurant-bar/nyclx-the-lexington-hotel-autograph-collection/6595470-the-stayton-room',
          },
        },
        {
          node: {
            basicInformation: {
              reservationUrl: 'http://www.opentable.com/restaurant/profile/1017811/reserve?restref=1017811',
            },
            contactInformation: {
              address: {
                city: 'New York',
                country: {
                  description: 'USA',
                },
                stateProvince: 'New York',
              },
            },
            cuisine: 'American',
            contactNumbers: null,
            description:
              'Enjoy outdoor dining in the Theater District, NYC, at The Terrace and Outdoor Gardens. This on-site terrace restaurant artfully blends American brasserie classics with a vegetable-forward approach, celebrating locally sourced ingredients.',
            diningExperience: {
              affordabilityPriceIndicator: null,
              capacity: 40,
              cuisines: ['French'],
              experiences: ['Private Functions'],
              hasPrivateDiningRoom: true,
              privateDiningRoomCapacity: 8,
              seatings: ['Private Dining Room'],
            },
            contactInfo: {
              contactNumbers: [
                {
                  phoneNumber: {
                    display: '+1 808 729-9729',
                  },
                },
              ],
            },
            id: 'NYCTE.6407448',
            media: {
              imageConnection: {
                edges: [
                  {
                    node: {
                      alternateDescription: 'The Terrace and Outdoor Gardens',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/nycte-terrace-6938:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/nycte-terrace-6938:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/nycte-terrace-6938:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/nycte-terrace-6938:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/nycte-terrace-6938:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/nycte-terrace-6938:Pano-Ver',
                        square: '/is/image/marriotts7prod/nycte-terrace-6938:Square',
                        wideHorizontal: '/is/image/marriotts7prod/nycte-terrace-6938:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/nycte-terrace-6938:Wide-Ver',
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycte-terrace-6938',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'The Terrace Restaurant and Outdoor Gardens',
                      imageUrls: {
                        classicHorizontal: '/is/image/marriotts7prod/nycte-restaurant-4798:Classic-Hor',
                        classicVertical: '/is/image/marriotts7prod/nycte-restaurant-4798:Classic-Ver',

                        featureHorizontal: '/is/image/marriotts7prod/nycte-restaurant-4798:Feature-Hor',
                        featureVertical: '/is/image/marriotts7prod/nycte-restaurant-4798:Feature-Ver',

                        panoramicHorizontal: '/is/image/marriotts7prod/nycte-restaurant-4798:Pano-Hor',
                        panoramicVertical: '/is/image/marriotts7prod/nycte-restaurant-4798:Pano-Ver',
                        square: '/is/image/marriotts7prod/nycte-restaurant-4798:Square',
                        wideHorizontal: '/is/image/marriotts7prod/nycte-restaurant-4798:Wide-Hor',
                        wideVertical: '/is/image/marriotts7prod/nycte-restaurant-4798:Wide-Ver',
                      },
                      isPrimaryArchitectural: true,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycte-restaurant-4798',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'The Terrace Bar - Detail',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-detail-4800-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-detail-4800-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-detail-4800-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCTE/nycte-detail-4800-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-detail-4800-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycte-detail-4800',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'The Terrace and Outdoor Gardens',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6939-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6939-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6939-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6939-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6939-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycte-terrace-6939',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'The Terrace and Outdoor Gardens',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6940-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6940-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6940-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6940-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6940-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycte-terrace-6940',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'The Terrace and Outdoor Gardens',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6941-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6941-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6941-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6941-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6941-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycte-terrace-6941',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'The Terrace and Outdoor Gardens',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6946-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6946-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6946-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6946-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-6946-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycte-terrace-6946',
                    },
                  },
                  {
                    node: {
                      alternateDescription: 'The Terrace and Outdoor Gardens',
                      imageUrls: {
                        classicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-8445-hor-clsc.jpg',
                        classicVertical: null,

                        featureHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-8445-hor-feat.jpg',
                        featureVertical: null,

                        panoramicHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-8445-hor-pano.jpg',
                        panoramicVertical: null,
                        square: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-8445-sq.jpg',
                        wideHorizontal: '/content/dam/marriott-renditions/NYCTE/nycte-terrace-8445-hor-wide.jpg',
                        wideVertical: null,
                      },
                      isPrimaryArchitectural: false,
                      isPrimaryServices: false,
                      isSecondaryArchitectural: false,
                      isSecondaryServices: false,
                      title: 'nycte-terrace-8445',
                    },
                  },
                ],
                total: 8,
              },
            },
            name: 'The Terrace and Outdoor Gardens',
            operationalDetails: {
              restaurantSoftware: 'OpenTable',
              restaurantSoftwareId: '1017811',
            },
            primaryType: 'Restaurant',
            productId: '6407448',
            property: {
              basicInformation: {
                latitude: 40.759115,
                longitude: -73.984126,
                name: 'The Times Square EDITION',
              },
            },
            secondaryType: 'Bar',
            seoUrl: 'restaurant-bar/nycte-the-times-square-edition/6407448-the-terrace-and-outdoor-gardens',
          },
        },
      ],
    },
  },
};
